/** Waits for the given number of seconds. */
export async function waitForSeconds(seconds: number): Promise<void> {
	await waitForMillis(seconds * 1000);
}

/** Waits for the given number of milliseconds. */
export async function waitForMillis(millis: number): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, millis));
}

export async function waitForImmediate() {
	return new Promise(requestAnimationFrame);
}